export default __webpack_public_path__ + "static/media/card_xxiv_premio_abt.55319823.png";